import { Routes } from '@angular/router';
import { ShellComponent } from './components/shell/shell.component';
import { AboutComponent } from './components/about/about.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';

export const routes: Routes = [
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },

  {
    path: '',
    component: ShellComponent,
    children: [
      { path: '', component: AboutComponent },
    ],
  },
];
